<template lang="html">
  <div class="v-loading-container" v-if="loading">
    <div class="v-loading">
      <img class="img" src="../../assets/loading1.gif" alt="Loading..."/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  mounted() {

  }
};
</script>

<style lang='less' scoped>
.v-loading-container {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 255);
  opacity: 0.5;
  .v-loading {
    // background-color: #FFFFFF;
    // box-shadow: 0 0 3px #aaa;
    border-radius: 4px;
    position: absolute;
    height: 60px;
    width: 60px;
    top: 50%;
    left: 50%;
    color: #666;
    margin-left: -30px;
    margin-top: -30px;
    text-align: center;
    padding-top: 14px;

    .img{
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Loading.vue?dcd0d770